import { render, staticRenderFns } from "./CallNotification.vue?vue&type=template&id=0e075cfa&scoped=true&lang=pug&"
import script from "./CallNotification.vue?vue&type=script&lang=ts&"
export * from "./CallNotification.vue?vue&type=script&lang=ts&"
import style0 from "./CallNotification.vue?vue&type=style&index=0&id=0e075cfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e075cfa",
  null
  
)

export default component.exports